import React, { ReactNode } from "react";
import * as styles from "./popup-sheet-content.module.scss";
import { classArr } from "../../helper/style-helper";

export interface PopupSheetContentProps {
	style?: React.CSSProperties;
	className?: string;
	children?: ReactNode;
}

/**
 * A content wrapper with background styling for popup sheets
 */
export default function PopupSheetContent(props: PopupSheetContentProps) {
	return (
		<div
			style={props.style}
			className={classArr(styles.content, props.className)}
		>
			{props.children}
		</div>
	);
}
